'use strict';

angular.module('internal.inspections')
    .controller('InternalInspectionChecklist', ['$scope', '$stateParams', 'IPChecklists', 'FBResponses', '$q', 'IPInspections', '$window', '$timeout', 'Session',
        function ($scope, $stateParams, IPChecklists, FBResponses, $q, IPInspections, $window, $timeout, Session) {
            $scope.resetInspection();
            $scope.checklist = $stateParams.checklist;
            $scope.masterChecklist = $stateParams.checklist;
            $scope.checklistID = $stateParams.checklistID;
            $scope.deficiencyScore = { score: 0 };
            $scope.deficiencies = {
                fail: 0,
                pass: 0,
                ignore: 0
            }
            $scope.saving = false;
            $scope.submitting = false;
            $scope.checklistForm = {};
            $scope.loadingMessage = '';
            $scope.failSubmit = false;
            $scope.failSubmitMessage = '';
            $scope.validationMessage = null;
            $scope.validationSuccess = false;

            $scope.getChecklist = function () {
                $scope.loading = true;

                IPChecklists.getByID($stateParams.checklistID).then(function (checklist) {
                    var promises = [];

                    if (checklist.response_id != null) {
                        promises.push(FBResponses.getByID(checklist.response_id).then(function (response) {
                            checklist.response = response;
                        }))
                    }
                    else if (checklist.template != null) {
                        promises.push(FBResponses.save({ Form_ID: checklist.template.form_id }, checklist.id).then(function (response) {
                            checklist.response_id = response.id;
                            checklist.response = response;
                        }))
                    }

                    $q.all(promises).then(function () {
                        $scope.deficiencies.fail = checklist.deficiencies_fail != null ? checklist.deficiencies_fail : 0;
                        $scope.deficiencies.pass = checklist.deficiencies_pass != null ? checklist.deficiencies_pass : 0;
                        $scope.deficiencies.ignore = checklist.deficiencies_ignore != null ? checklist.deficiencies_ignore : 0;

                        $scope.checklist = checklist;

                        if ($scope.checklist.template.require_responsible_party_signoff === true && ($scope.checklist.signature_type_in_person === null || $scope.checklist.signature_type_in_person === undefined)) {
                            $scope.checklist.signature_type_in_person = true;
                        }

                        $scope.passingChecklist = $scope.checklist.template;
                        $scope.passingChecklist.inspectionID = $scope.$parent.inspectionID;
                        $scope.masterChecklist = angular.copy($scope.checklist);
                        $scope.loading = false;
                    }).catch(function (response) {
                        // handle error
                    });
                });
            }

            $scope.clearSignature = function () {
                // we need to clear out the values if we select "virtual" for signature, but we don't want to clear it out if its already signed
                if ($scope.checklist.signature_type_in_person == false && $scope.checklist.checklist_signed != true) {
                    $scope.checklist.signature_first_name = null;
                    $scope.checklist.signature_last_name = null;
                    $scope.checklist.signature_certification_number = null;
                    $scope.checklist.signature_photo_source = null;
                    $scope.checklistForm.signature = null;
                }
            }

            $scope.$watch('inspection.reinspect', function () {
                if ($scope.inspection.reinspect) {
                    $scope.inspection.reinspection_date = new Date();
                    $scope.inspection.reinspection_date.setHours(0, 0, 0, 0);
                    if ($scope.checklist.template.reinspection != null) {
                        $scope.inspection.reinspection_date.setDate($scope.inspection.reinspection_date.getDate() + $scope.checklist.template.reinspection);
                    }
                }
            })

            if ($stateParams.checklistID != null) {
                $scope.getChecklist();
            }

            $scope.complete = function () {
                return $scope.deficiencies.fail + $scope.deficiencies.pass + $scope.deficiencies.ignore == $scope.checklist.template.deficiencies_total;
            }

            $scope.failed = function () {
                if ($scope.checklist.template.passing_score_type) {
                    return $scope.checklist.template.passing_score > $scope.deficiencyScore.score;
                }
                else {
                    return $scope.deficiencies.fail >= $scope.checklist.template.auto_fail;
                }
            }

            $scope.save = function (checklist, the_form) {
                Session.checkIn();

                //Reset any previous validation messages
                $scope.validationMessage = null;
                $scope.validationSuccess = false;
                the_form.validationMessages = null;

                var formValid = the_form.$valid;

                $scope.saving = true;
                $scope.saveChecklist(checklist);
                $scope.inspection.reinspect = false;
                $scope.inspection.checklist = checklist;

                $scope.failSubmit = false;
                $scope.loadingMessage = "Saving Checklist...";
                IPInspections.saveIPChecklist($scope.inspection.checklist, $scope.inspection.id).then(function (savedChecklist) {
                    if (savedChecklist != null) {
                        IPInspections.save($scope.inspection, false, false).then(function (savedInspection) {
                            savedChecklist = null;
                            savedInspection = null;
                            $scope.saving = false;
                            $scope.failSubmit = false;

                            if (formValid) {
                                $scope.validationMessage = "All required information has been supplied";
                                $scope.validationSuccess = true;
                            }
                            else {
                                $scope.validationMessage = "Checklist saved, but required information is missing";
                                $scope.validationSuccess = false;
                            }
                            $window.scrollTo(0, 0);

                            var validationTimeout = $timeout(function () {
                                $scope.validationMessage = null;
                                $scope.validationSuccess = false;
                            }, 3000);

                            $scope.$on('$destroy', function () {
                                $timeout.cancel(validationTimeout);
                            });
                        });
                    }
                    else {
                        $scope.saving = false;
                        $scope.failSubmit = true;
                        $scope.failSubmitMessage = "Save of inspection failed, and the form data was not saved. Please try saving the inspection again.";
                    }

                    // Deficiency component reloads, so we have to also reset score
                    $scope.deficiencyScore.score = 0;
                    $scope.getChecklist();
                    $scope.getInspection();
                });
            }

            $scope.submit = function (checklist) {
                Session.checkIn();

                //Reset any previous validation messages
                $scope.validationMessage = null;
                $scope.validationSuccess = false;

                var d = $q.defer();

                var promises = [];
                $scope.submitting = true;
                $scope.failSubmit = false;
                $scope.loadingMessage = "Saving Checklist...";
                $scope.saveChecklist(checklist);
                if (!$scope.complete() || !$scope.failed()) {
                    $scope.inspection.reinspect = false;
                }
                $scope.inspection.checklist = checklist;

                IPInspections.saveIPChecklist($scope.inspection.checklist, $scope.inspection.id).then(function (savedChecklist) {
                    if (savedChecklist != null) {
                        promises.push(IPInspections.save($scope.inspection, true, false)); //Save inspection

                        $scope.loadingMessage = "Gathering data for pdf generation...";
                        promises.push(IPChecklists.getDocumentsAndComments($scope.inspection)
                            .then(function (inspection) {
                                if (inspection != null) {
                                    $scope.loadingMessage = "Generating PDF...";
                                    IPChecklists.generatingPDF($scope.inspection)
                                        .then(function (successGeneratePDF) {
                                            if (successGeneratePDF) {
                                                $scope.failSubmit = false;
                                                d.resolve(true);
                                            }
                                            else {
                                                $scope.failSubmit = true;
                                                $scope.failSubmitMessage = "Inspection PDF failed to generate. Form data successfully saved and PDF can be regenerated at another time by resubmitting the form.";
                                                d.resolve(false);
                                            }
                                            // Deficiency component reloads, so we have to also reset score
                                            $scope.deficiencyScore.score = 0;
                                            $scope.getChecklist();
                                            $scope.getInspection();
                                        });
                                }
                                else {
                                    $scope.failSubmit = true;
                                    $scope.failSubmitMessage = "Gathering data for pdf generation failed. Form data successfully saved and PDF can be regenerated at another time by resubmitting the form.";
                                    d.resolve(false);
                                }
                            })
                        );

                        $q.all(promises).then(function (arr) {
                            $scope.submitting = false;
                        }).catch(function (response) {
                            // handle error
                        });
                    }
                    else {
                        $scope.submitting = false;
                        $scope.failSubmit = true;
                        $scope.failSubmitMessage = "Submission of inspection failed, and the form data was not saved. Please try submitting the inspection again.";
                        d.resolve(false);
                    }
                });
            }

            $scope.saveChecklist = function (checklist) {
                if ($scope.checklistForm.signature != null) {
                    checklist.signature_photo_source = $scope.checklistForm.signature.toDataURL();
                }

                if ($scope.checklist.template.require_responsible_party_signoff === true
                    && ($scope.checklist.template.virtual_signature === false || ($scope.checklist.template.virtual_signature === true && $scope.checklist.signature_type_in_person === true))) {
                    $scope.checklist.checklist_signed = true;
                }

                checklist.deficiencies_fail = $scope.deficiencies.fail;
                checklist.deficiencies_pass = $scope.deficiencies.pass;
                checklist.deficiencies_ignore = $scope.deficiencies.ignore;
                if ($scope.complete()) {
                    $scope.inspection.outcome = !$scope.failed();
                }
                else {
                    $scope.inspection.outcome = null;
                }
            }

            $scope.resize = function () {
                if (document != null && document.querySelector != null) {
                    var canvas = document.querySelector("canvas");

                    if (canvas != null && canvas.offsetWidth != null && canvas.offsetHeight != null && canvas.getContext != null) {
                        var ratio = Math.max(window.devicePixelRatio || 1, 1);
                        canvas.width = canvas.offsetWidth * ratio;
                        canvas.height = canvas.offsetHeight * ratio;
                        canvas.getContext("2d").scale(ratio, ratio);
                    }
                }
            }
        }])
    ;